export default __webpack_public_path__ + "static/media/thumbnail_blog_6.f8326216.png";